export default {
	common: {
		pl_search: 'Please enter search keyword',
		handle: 'Action',
		ends_at: 'Expired at',
		created_at: 'Created at',
		pay_at: 'Paid at',
		action_success: 'Action successful',
		tip: 'Tip',
		cancel: 'Cancel',
		confirm: 'OK',
		unpaid: 'Unpaid',
		paid: 'Paid',
		payment_failed: 'Payment failed',
		cancelled: 'Cancelled',
		edit_success: 'Edit successful',
		pl_start_at: 'Select start date',
		pl_ends_at: 'Select end date',
		back: 'Back',
		msg_edit:
			'The content edited this time has not been saved, are you sure you want to abandon the changes?',
		msg_edit_title: 'Abandon current changes?',
		submit_leave: 'Are you sure you want to leave the current page?',
		start_at: 'Start date',
		end_at: 'End date',
		msg_title: 'Confirm the execution of this operation?',
		warning: 'Warning',
		close: 'Close',
		copy_success: 'Copy succeeded',
		copy_failed: 'Copy failed',
		more: 'View more',
		gmt5: '(GMT-05:00) Eastern Time (US & Canada)',
		gmt8: '(GMT+08:00) Beijing Time',
		'gmt-7': '(GMT-07:00) Arizona Time',
		'gmt-8': '(GMT-08:00) Pacific Time',
		'gmt-9': '(GMT-09:00) Alaska Time',
		man_refresh: 'Refresh',
		not_upload: 'Not uploaded',
		uploaded: 'Uploaded',
		upload_fail: 'Upload failed',
	},
}
